export const invoicesHeaders = [
  'billing_at',
  'payment_method',
  'amount',
  'status',
  'details',
  'bank_slip'
]
